var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.572,
    height: 14.804,
    viewBox: "0 0 15.572 14.804",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3748",
    "data-name": "Group 3748",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6546",
    "data-name": "Path 6546",
    d: "M-2874.04-3342.9v-5.676c0-.067,0-.067.067-.08l1.984-.374,1.722-.325,2.158-.407,1.506-.284,1.336-.25c.057-.011.057-.011.057.045v1.372c0,.063,0,.063.063.063h5.913a.743.743,0,0,1,.579.242.708.708,0,0,1,.187.462v10.385a.711.711,0,0,1-.374.655.705.705,0,0,1-.36.092h-5.932c-.083,0-.073-.01-.073.073v1.361c0,.052,0,.053-.051.044l-.9-.169-1.857-.35-1.586-.3-1.79-.337-1.827-.344c-.256-.048-.512-.1-.768-.143-.043-.008-.058-.022-.058-.069Q-2874.04-3340.06-2874.04-3342.9Z",
    transform: "translate(2874.041 3350.302)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6547",
    "data-name": "Path 6547",
    d: "M-1850.19-3106.79a.1.1,0,0,0-.051,0h-2.038c-.036,0-.049-.006-.048-.046v-.4c0-.039.008-.05.049-.05h2.039c.043,0,.051-.012.051-.052v-1.244c0-.046-.014-.054-.057-.054h-2.035c-.039,0-.048-.009-.047-.047v-.9c.013-.01.028-.006.042-.006h6.034c.014,0,.029-.006.041.006h0c.013.012.007.027.007.041V-3099c0,.014.006.029-.007.04h0c-.012.013-.027.006-.041.006h-6.034a.121.121,0,0,1-.042,0v-.9c0-.038.008-.048.047-.048h2.03c.063,0,.063,0,.063-.062v-1.235c0-.045-.014-.052-.055-.052h-2.034c-.039,0-.05-.009-.049-.049v-.374c0-.035.01-.042.043-.042h2.059c.042,0,.052-.009.052-.052V-3103c0-.04-.007-.052-.051-.052h-2.052c-.04,0-.05-.01-.049-.049v-.411c0-.037.01-.044.045-.044h2.047c.041,0,.053-.008.052-.051v-1.253c0-.014.009-.031-.007-.044a.1.1,0,0,1-.047,0h-2.037c-.016,0-.034.006-.05-.006v-.5c0-.02.008-.025.026-.024h2.059a.113.113,0,0,0,.052,0Q-1850.19-3106.12-1850.19-3106.79Z",
    transform: "translate(1861.151 3111.673)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6548",
    "data-name": "Path 6548",
    d: "M-2618.93-2806.82c.007-.028.016-.056.024-.084a4.928,4.928,0,0,1,.334-.845c.149-.33.3-.66.447-.99a.069.069,0,0,1,.07-.047c.352-.023.7-.049,1.055-.073h.039a.081.081,0,0,1-.017.044q-.657,1.254-1.315,2.506a.088.088,0,0,0,0,.094q.679,1.276,1.356,2.553l.024.046-.3-.02-.573-.04-.312-.021a.052.052,0,0,1-.051-.035q-.363-.815-.728-1.63a1.433,1.433,0,0,1-.082-.3.1.1,0,0,0-.013-.043s-.009.01-.009.014a2.686,2.686,0,0,1-.228.624q-.283.608-.561,1.218a.052.052,0,0,1-.062.035l-.861-.062-.148-.012.063-.125,1.173-2.2a.068.068,0,0,0,0-.071l-1.11-2.271v-.007c-.021-.044-.021-.043.026-.046l.811-.057c.062,0,.125-.006.187-.012a.048.048,0,0,1,.036.006.046.046,0,0,1,.021.03c.145.358.292.715.437,1.073a4.423,4.423,0,0,1,.246.676c0,.022.011.044.017.066Z",
    transform: "translate(2623.026 2813.536)",
    fill: "#1da193"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6562",
    "data-name": "Path 6562",
    d: "M-1539.89-2785.69h1.185c.038,0,.044.011.044.045v1.261c0,.037-.011.044-.046.044h-2.354c-.042,0-.051-.011-.051-.052v-1.253c0-.04.012-.046.048-.046Z",
    transform: "translate(1552.621 2790.565)",
    fill: "#1da193"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6562-2",
    "data-name": "Path 6562",
    d: "M-1540.045-2785.69h1.034c.033,0,.038.011.038.045v1.261c0,.037-.01.044-.04.044h-2.055c-.037,0-.045-.011-.045-.052v-1.253c0-.04.01-.046.042-.046Z",
    transform: "translate(1549.936 2790.565)",
    fill: "#1da193"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6563",
    "data-name": "Path 6563",
    d: "M-1538.65-2997.74h-2.388c-.039,0-.049-.009-.049-.048v-1.261c0-.027,0-.04.036-.04h2.4a.067.067,0,0,1,0,.038v1.269a.07.07,0,0,1,0,.042Z",
    transform: "translate(1552.603 3002.124)",
    fill: "#1da193"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6563-2",
    "data-name": "Path 6563",
    d: "M-1538.957-2997.74h-2.088c-.034,0-.043-.009-.043-.048v-1.261c0-.027,0-.04.031-.04h2.1a.075.075,0,0,1,0,.038v1.269a.079.079,0,0,1,0,.042Z",
    transform: "translate(1549.918 3002.124)",
    fill: "#1da193"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6564",
    "data-name": "Path 6564",
    d: "M-1538.65-2143.79h-2.388c-.039,0-.049-.009-.049-.049v-1.261c0-.027,0-.04.036-.04h2.4a.067.067,0,0,1,0,.038v1.269A.068.068,0,0,1-1538.65-2143.79Z",
    transform: "translate(1552.603 2155.549)",
    fill: "#1da193"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6564-2",
    "data-name": "Path 6564",
    d: "M-1538.957-2143.79h-2.087c-.034,0-.043-.009-.043-.049v-1.261c0-.027,0-.04.031-.04h2.1a.076.076,0,0,1,0,.038v1.269A.077.077,0,0,1-1538.957-2143.79Z",
    transform: "translate(1549.918 2155.549)",
    fill: "#1da193"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6565",
    "data-name": "Path 6565",
    d: "M-1539.84-2354.18h1.179c.032,0,.044.006.043.041v1.261c0,.032-.007.041-.039.04h-2.37c-.034,0-.039-.01-.039-.041v-1.261c0-.032.007-.041.04-.041Z",
    transform: "translate(1552.58 2362.781)",
    fill: "#1da193"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6565-2",
    "data-name": "Path 6565",
    d: "M-1540-2354.18h1.028c.028,0,.038.006.037.041v1.261c0,.032-.006.041-.034.04h-2.066c-.03,0-.034-.01-.034-.041v-1.261c0-.032.006-.041.035-.041Z",
    transform: "translate(1549.895 2362.781)",
    fill: "#1da193"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6570",
    "data-name": "Path 6570",
    d: "M-1537.93-2567.09h1.153c.043,0,.057.01.057.055v1.213c0,.045-.014.055-.057.055h-2.308c-.041,0-.054-.01-.054-.052v-1.218c0-.042.014-.053.054-.052Z",
    transform: "translate(1550.671 2573.857)",
    fill: "#1da193"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6570-2",
    "data-name": "Path 6570",
    d: "M-1538.081-2567.09h1.009c.038,0,.05.01.05.055v1.213c0,.045-.012.055-.05.055h-2.02c-.036,0-.047-.01-.047-.052v-1.218c0-.042.012-.053.047-.052Z",
    transform: "translate(1547.986 2573.857)",
    fill: "#1da193"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelIcon);
export default __webpack_public_path__ + "static/media/excel_icon.b50a1a57efa690f774d21b0903be3d70.svg";
export { ForwardRef as ReactComponent };